import React from "react";

import * as FaIcons from "react-icons/fa";

const R10MigrantEducation = ({
  formData,
  onFormDataChange,
  validationCheck,
}) => {
  const { firstName, isPgEmployedInOneOrMoreAgriculturalOrFishingActivities } =
    formData;
  return (
    <>
      {/* Migrant Education */}
      <div className="sub-form">
        <h3>Migrant Education</h3>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Is {firstName === "" ? "the Student" : firstName}'s
              Parent/Guardian Employed in One or More Agricultural or Fishing
              Activities on a Season or Other Temporary Basis?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  isPgEmployedInOneOrMoreAgriculturalOrFishingActivities[
                    "yes"
                  ] ||
                  isPgEmployedInOneOrMoreAgriculturalOrFishingActivities["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={
                  isPgEmployedInOneOrMoreAgriculturalOrFishingActivities["yes"]
                }
                onChange={(e) => onFormDataChange(e)}
                name="isPgEmployedInOneOrMoreAgriculturalOrFishingActivities"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={
                  isPgEmployedInOneOrMoreAgriculturalOrFishingActivities["no"]
                }
                onChange={(e) => onFormDataChange(e)}
                name="isPgEmployedInOneOrMoreAgriculturalOrFishingActivities"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default R10MigrantEducation;
